<template>
  <ks-popover
      v-if="popoverValue"
      :hoverText="popoverValue"
      :showAsHtml="htmlPopover"
      :iconValue="(abbreviated ? `${app.abbreviatedIcons(icon)}` : `${icon}`) + ` fa-${size}x`"
      :abbreviated="abbreviated"
      :class="classes"
      @onClick="$emit('onClick')"
  />
  <span v-else>
    <i
        :class="(abbreviated ? `${app.abbreviatedIcons(icon)}` : `${icon}`) + ` fa-${size}x` + ' ' + classes" :key="_uid"
        @click="$emit('onClick')"
    >
    </i>
  </span>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: "ks-icon",
  mixins: [checkPermissions],
  props: {
    icon: {type: String, required: true},
    size: {type: String, default: "1",},
    popoverValue: {type: String, default: null},
    htmlPopover: {type: Boolean, default: false},
    abbreviated: {type: Boolean, default: true},
    classes: {type: String, default: null}
  },
  computed: {
    app() {
      return app;
    },
  }
}
</script>
